function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardSeatPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.677,
    height: 49.999,
    viewBox: "0 0 41.677 49.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 18"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 81",
    d: "M60.8 362.074h5.045v14.641H60.8z",
    transform: "translate(-54.86 -326.716)",
    style: {
      fill: "#657488"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 82",
    d: "M51.993 484.081h-5.976A1.084 1.084 0 0 1 44.934 483v-.832a1.084 1.084 0 0 1 1.084-1.084h5.976a1.084 1.084 0 0 1 1.084 1.084V483a1.084 1.084 0 0 1-1.085 1.081z",
    transform: "translate(-40.546 -434.102)",
    style: {
      fill: "#657488"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 83",
    d: "M314.32 362.074h5.046v14.641h-5.046z",
    transform: "translate(-283.625 -326.716)",
    style: {
      fill: "#657488"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 84",
    d: "M94.083 32.04H65.125V6.361A6.361 6.361 0 0 1 71.486 0h16.236a6.361 6.361 0 0 1 6.361 6.361z",
    transform: "translate(-58.765)",
    style: {
      fill: "#ff8577"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 85",
    d: "M248.924 0h-5.151a6.361 6.361 0 0 1 6.361 6.361V32.04h5.151V6.361A6.361 6.361 0 0 0 248.924 0z",
    transform: "translate(-219.968)",
    style: {
      fill: "#ff6b6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 86",
    d: "M6.36 217.7v-14.452a1.76 1.76 0 0 0-1.76-1.76H1.76a1.76 1.76 0 0 0-1.76 1.76v8.092a6.36 6.36 0 0 0 6.36 6.36z",
    transform: "translate(0 -181.812)",
    style: {
      fill: "#ff6b6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 87",
    d: "M361.656 217.7v-14.452a1.76 1.76 0 0 1 1.76-1.76h2.839a1.76 1.76 0 0 1 1.76 1.76v8.092a6.36 6.36 0 0 1-6.359 6.36z",
    transform: "translate(-326.339 -181.812)",
    style: {
      fill: "#ff8577"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 88",
    d: "M76.148 353.834H46.621a1.687 1.687 0 0 1-1.687-1.687v-4.088h32.9v4.088a1.687 1.687 0 0 1-1.686 1.687z",
    transform: "translate(-40.546 -314.069)",
    style: {
      fill: "#93a6b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 89",
    d: "M49.693 306.428H16.65a2.982 2.982 0 0 1-2.982-2.982 4.723 4.723 0 0 1 4.723-4.723h29.561a4.723 4.723 0 0 1 4.723 4.723 2.982 2.982 0 0 1-2.982 2.982z",
    transform: "translate(-12.333 -269.551)",
    style: {
      fill: "#fa9e92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 90",
    d: "M305.52 484.081h-5.976a1.084 1.084 0 0 1-1.083-1.081v-.832a1.084 1.084 0 0 1 1.084-1.084h5.976a1.084 1.084 0 0 1 1.084 1.084V483a1.084 1.084 0 0 1-1.085 1.081z",
    transform: "translate(-269.315 -434.102)",
    style: {
      fill: "#657488"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 91",
    d: "M144.452 81.408a6.811 6.811 0 1 0 6.811 6.811 6.811 6.811 0 0 0-6.811-6.811zm2.3 9.107a.619.619 0 0 1-.876 0l-1.858-1.858a.619.619 0 0 1-.181-.438V84.5a.619.619 0 1 1 1.238 0v3.459l1.676 1.676a.619.619 0 0 1 0 .876z",
    transform: "translate(-124.2 -73.458)",
    style: {
      fill: "#facdc3"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSeatPending);
export default __webpack_public_path__ + "static/media/dashboard-seat-pending.72fd3fc5ff4174c479ce53fd1311f8cd.svg";
export { ForwardRef as ReactComponent };